var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelledMoneyPledge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.89502 11.3671L9.98562 14.8132L19.3124 8.84081L14.0708 5.35529L4.89502 11.3671Z",
    stroke: "#627890",
    strokeWidth: 0.728199,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5767 6.35802L15.3621 6.4646C14.3369 7.12775 12.8387 6.4646 12.8387 6.4646C12.8387 6.4646 12.6559 6.37381 12.6201 6.3067",
    stroke: "#627890",
    strokeWidth: 0.728199,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8577 9.76835C17.7191 9.65285 17.608 9.50827 17.5324 9.34502C17.4568 9.18176 17.4186 9.0039 17.4205 8.82421C17.4224 8.64453 17.4644 8.4675 17.5434 8.30586C17.6224 8.14422 17.7365 8.00199 17.8775 7.8894",
    stroke: "#627890",
    strokeWidth: 0.728199,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66211 13.9171C8.66211 13.9171 9.70328 13.1276 11.4439 13.8776",
    stroke: "#627890",
    strokeWidth: 0.728199,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33325 10.4355C6.33325 10.4355 7.39827 11.4736 6.33325 12.3302",
    stroke: "#627890",
    strokeWidth: 0.728199,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.68433 12.4685L10.0531 15.9224L19.4475 9.90271",
    stroke: "#627890",
    strokeWidth: 0.728199,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.68433 13.5618L10.0531 16.9526L19.4316 10.9763",
    stroke: "#627890",
    strokeWidth: 0.728199,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.68433 14.6632L10.0531 18.1053L19.4316 12.054",
    stroke: "#627890",
    strokeWidth: 0.728199,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2913 8.93164L13.8638 11.2922",
    stroke: "#627890",
    strokeWidth: 0.728199,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0161 9.00271C12.0161 9.00271 10.3431 8.91587 10.3391 9.73692C10.3351 10.558 11.7141 10.2738 12.0161 10.1317C12.493 9.92639 13.9276 9.4606 13.7726 10.6843C13.6574 11.2724 12.2546 11.2093 12.2546 11.2093",
    stroke: "#627890",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2 2C6.56668 2 2 6.56668 2 12.2C2 17.8333 6.56668 22.4 12.2 22.4C17.8333 22.4 22.4 17.8333 22.4 12.2C22.4 6.56668 17.8333 2 12.2 2ZM5.91816 18.4818C2.60225 15.1659 2.45719 9.88764 5.46985 6.40048L17.9996 18.9301C14.5117 21.9434 9.2334 21.7971 5.91816 18.4818V18.4818ZM18.9301 17.9995L6.40048 5.46985C9.88838 2.45661 15.1666 2.60295 18.4818 5.91816C21.7977 9.23402 21.9428 14.5124 18.9301 17.9995V17.9995Z",
    fill: "#627890"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelledMoneyPledge);
export default __webpack_public_path__ + "static/media/cancelled_money_pledge.da47dede300bdf2a23999d41b5857f44.svg";
export { ForwardRef as ReactComponent };